import { css, html, LitElement } from 'lit';
import { Text } from '../Text/Text';
import '../ContactTile/ContactTile.js';
import '../GroupChatContacts/GroupChatContacts.js';
import '../../../stories/Components/Loader/Spinner/Spinner.js';
import '../Placeholder/NoContactsPlaceholder.js';
import { WEB_CONTENT } from '../../../constants/content.js';
import { Image } from '../Image/Image.js';
import { Group } from '../../../constants/chat-assets.js';

class NewChatSidebar extends LitElement {
  static styles = css`
    .searchable-list-topbar svg {
      cursor: pointer;
    }

    ::-webkit-scrollbar {
      width: 5px;
    }

    ::-webkit-scrollbar-track {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background-color: var(--bg-primary-light) !important;
      border-radius: 10px;
    }

    input {
      border: none;
      outline: none;
      padding: 5px;
      width: 97%;
      background-color: var(--bg-secondary-color);
      color: var(--text-primary-color);
    }

    input::placeholder {
      color: var(--text-primary-color);
    }
    .new-chat-container {
      display: flex;
      flex-direction: column;
      gap: 5px;
      height: 100%;
      width: 100%;
    }
    .new-chat-topbar {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 20px;
      padding: 10px;
      font-size: var(--title-font-size);
    }
    .new-chat-topbar svg {
      cursor: pointer;
    }
    .new-chat-sidebar-searchbar {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 5px 10px;
      border-radius: 5px;
      margin: 10px;
      background-color: var(--bg-secondary-color);
      color: var(--text-primary-color);
    }
      .new-chat-sidebar-searchbar input{
      height:40px;
      font-size:1rem;
      }

    .new-chat-sidebar-searchbar svg {
      width: 20px;
      height: 20px;
    }

    .new-chat-sidebar-body {
      display: flex;
      flex-direction: column;
      width: 100%;
      background-color: var(--bg-primary-color);
      flex-grow: 1;
      overflow-y: auto;
    }
    .new-chat-tile-list {
      width: 100%;
      max-height: 90%;
      overflow-y: auto;
      overflow-x: hidden;
      flex-grow: 1;
    }

    .create-group-button,
    .create-groupcast-button {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 15px;
      border-radius: 5px;
      background-color: var(--bg-primary-light);
      cursor: pointer;
      font-size: 18px;
      color: var(--text-primary-color);
    }
    
   
    .create-groupcast-button {
      margin-top: 10px;
    }

    .create-group-button svg,
    .create-groupcast-button svg {
      background-color: var(--bg-primary-color);
      width: 35px;
      height: 35px;
      padding: 5px;
      border-radius: 50%;
    }

    .loading-container {
       width: 100%;
       bottom: 0;
       left: 0;
       background-color: var(--bg-primary-color);
       padding: 10px;
    }


    .group-chat-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 25vw;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.7);
      display: flex;
      z-index: 1000;
      transition: transform 0.3s ease;
      transform: translateX(-100%);
    }

    .group-chat-overlay.show {
      transform: translateX(0);
    }

    .group-chat-overlay.hide {
      transform: translateX(-100%);
    }

    group-chat-contacts {
      width: 95%;
      height: 100%;
    }

    .loader {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      color: var(--text-primary-color);
    }

    .loader:after {
      content: '';
      width: 20px;
      height: 20px;
      border: 2px solid #f3f3f3;
      border-top: 2px solid var(--bg-primary-light);
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }

    @media (width < 768px) {
      .new-chat-container {
        width: 100%;
      }
  `;
  static properties = {
    bgColor: { type: String },
    borderWidth: { type: String },
    borderColor: { type: String },
    borderStyle: { type: String },
    borderRadius: { type: String },
    padding: { type: String },
    height: { type: String },
    width: { type: String },
    label: { type: String },
    fontSize: { type: String },
    fontFamily: { type: String },
    textColor: { type: String },
    contacts: { type: Array },
    closeNewChatSidebar: { type: Function },
    nonBlockedContacts: { type: Array },
    searchQuery: { type: String },
    isNoContactsFound: { type: Boolean },
    showGroupChatContacts: { type: Boolean },
    isLoading: { type: Boolean },
    showGroupCastContacts: { type: Boolean },
    isLoadingMember: { type: Boolean },
    hasMoreMembers: { type: Boolean },
    isPaginationMember: { type: Boolean },
    renderComponentName: { type: String },
  };

  constructor() {
    super();
    this.fontSize = '18px';
    this.bgColor = '#ffffff';
    this.borderWidth = '1px';
    this.borderColor = '#000000';
    this.borderStyle = 'solid';
    this.borderRadius = '5px';
    this.padding = '10px 0px';
    this.height = 'auto';
    this.label = 'New Chat';
    this.fontFamily = 'Arial, sans-serif';
    this.textColor = '#000000';
    this.searchQuery = '';
    this.debounceTimeout = null;
    this.DEBOUNCE_DELAY = 700; // 700ms debounce delay
    this.showGroupChatContacts = false;
    this.isLoading = false;
    this.nonBlockedContacts = [];
    this.isLoadingMore = false;
    this.hasSearchQuery = false;
    this.showGroupCastContacts = false;

    this.addEventListener('close-all-overlays', () => {
      this.closeAllOverlays();
    });
  }

  // updated(changedProperties) {
  //   if (changedProperties.has('nonBlockedContacts')) {
  //     this.isLoading = false;
  //     this.isLoadingMore = false;
  //   }
  // }

  // willUpdate(changedProperties) {

  //   if (changedProperties.has('conversationData')) {
  //     this.isLoading = false;
  //     this.isLoadingMore = false;
  //   }
  // }

  willUpdate(changedProperties) {
    if (changedProperties.has('conversationData')) {
      this.isLoading = false;
    }
  }

  clearSearchInput() {
    const searchInput = this.shadowRoot.querySelector('.new-chat-sidebar-searchbar input');
    if (searchInput) {
      searchInput.value = '';
      this.hasSearchQuery = false;
      this.isLoading = true;

      // Dispatch an input event to trigger the search reset
      this.dispatchEvent(
        new CustomEvent('new-chat-input-changed', {
          detail: {
            inputValue: '',
            isDebounced: false,
          },
          bubbles: true,
          composed: true,
        }),
      );
    }
  }

  render() {
    const svgSize = `calc(${this.fontSize} + 4px)`;

    return this.showGroupCastContacts
      ? html`
          <group-chat-contacts
            .closeGroupChatContacts=${() => this.closeGroupCastOverlay()}
            height="96%"
            width="100%"
            label="Create New Groupcast"
            bgColor="var(--bg-primary-color)"
            textColor="var(--text-primary-color)"
            .nonBlockedContacts=${this.nonBlockedContacts}
              .isNoContactsFound=${this.isNoContactsFound}
              .isPaginationMember=${this.isPaginationMember}
              .isLoadingMember=${this.isLoadingMember}
              .hasMoreMembers=${this.hasMoreMembers}
            .isGroupCast=${true}
          ></group-chat-contacts>
        `
      : this.showGroupChatContacts
        ? html`
            <group-chat-contacts
              .closeGroupChatContacts=${() => this.closeGroupChatOverlay()}
              height="96%"
              width="100%"
              label="Create New Group"
              bgColor="var(--bg-primary-color)"
              textColor="var(--text-primary-color)"
              .nonBlockedContacts=${this.nonBlockedContacts}
              .isNoContactsFound=${this.isNoContactsFound}
              .isPaginationMember=${this.isPaginationMember}
              .isLoadingMember=${this.isLoadingMember}
              .hasMoreMembers=${this.hasMoreMembers}
            ></group-chat-contacts>
          `
        : html`
            <div class="new-chat-container" style="background-color: ${this.bgColor}; padding: ${this.padding}; height: ${this.height}; width: ${this.width};">
              <div class="new-chat-topbar">
                <svg @click=${this.closeNewChatSidebar} xmlns="http://www.w3.org/2000/svg" height="${svgSize}" viewBox="0 -960 960 960" width="${svgSize}" fill="${this.textColor}">
                  <path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z" />
                </svg>
                ${Text({
                  content: this.label,
                  fontSize: this.fontSize,
                  fontFamily: this.fontFamily,
                  color: this.textColor,
                  fontWeight: 500,
                })}
              </div>
              <div class="new-chat-sidebar-body">
                <div class="new-chat-sidebar-searchbar">
                  <input id="search-input" placeholder="${WEB_CONTENT.PLACEHOLDER_CONTENT.SEARCH_FOR_NAME_OR_NUMBER}" @input="${this.handleInputChange}" />
                  ${this.hasSearchQuery
                    ? html`
                        <svg
                          style="cursor: pointer;"
                          @click=${this.clearSearchInput}
                          width="${svgSize}"
                          height="${svgSize}"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path
                              d="M6.22566 4.81096C5.83514 4.42044 5.20197 4.42044 4.81145 4.81096C4.42092 5.20148 4.42092 5.83465 4.81145 6.22517L10.5862 11.9999L4.81151 17.7746C4.42098 18.1651 4.42098 18.7983 4.81151 19.1888C5.20203 19.5793 5.8352 19.5793 6.22572 19.1888L12.0004 13.4141L17.7751 19.1888C18.1656 19.5793 18.7988 19.5793 19.1893 19.1888C19.5798 18.7983 19.5798 18.1651 19.1893 17.7746L13.4146 11.9999L19.1893 6.22517C19.5799 5.83465 19.5799 5.20148 19.1893 4.81096C18.7988 4.42044 18.1657 4.42044 17.7751 4.81096L12.0004 10.5857L6.22566 4.81096Z"
                              fill="${this.textColor}"
                            />
                          </g>
                        </svg>
                      `
                    : html`
                        <svg width="${svgSize}" height="${svgSize}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M17.0392 15.6244C18.2714 14.084 19.0082 12.1301 19.0082 10.0041C19.0082 5.03127 14.9769 1 10.0041 1C5.03127 1 1 5.03127 1 10.0041C1 14.9769 5.03127 19.0082 10.0041 19.0082C12.1301 19.0082 14.084 18.2714 15.6244 17.0392L21.2921 22.707C21.6828 23.0977 22.3163 23.0977 22.707 22.707C23.0977 22.3163 23.0977 21.6828 22.707 21.2921L17.0392 15.6244ZM10.0041 17.0173C6.1308 17.0173 2.99087 13.8774 2.99087 10.0041C2.99087 6.1308 6.1308 2.99087 10.0041 2.99087C13.8774 2.99087 17.0173 6.1308 17.0173 10.0041C17.0173 13.8774 13.8774 17.0173 10.0041 17.0173Z"
                              fill="${this.textColor}"
                            ></path>
                          </g>
                        </svg>
                      `}
                </div>
                <div class="create-group-button" @click="${this.handleCreateGroupClick}">
                  <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="var(--text-primary-color)">
                    <path
                      d="M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z"
                    />
                  </svg>
                  Create New Group
                </div>
                <div class="create-groupcast-button" @click="${this.handleCreateGroupCastClick}">
                  <svg xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="var(--text-primary-color)">
                    <path
                      d="M720-440v-80h160v80H720Zm48 280-128-96 48-64 128 96-48 64Zm-80-480-48-64 128-96 48 64-128 96ZM200-200v-160h-40q-33 0-56.5-23.5T80-440v-80q0-33 23.5-56.5T160-600h160l200-120v480L320-360h-40v160h-80Zm240-182v-196l-98 58H160v80h182l98 58Zm120 36v-268q27 24 43.5 58.5T620-480q0 41-16.5 75.5T560-346ZM300-480Z"
                    />
                  </svg>
                  Create New Groupcast
                </div>
                <div class="new-chat-tile-list" @scroll="${this.handleScroll}">
                  ${this.isLoadingMemeber
                    ? html`<spinner-loader
                        height="15px"
                        width="15px"
                        spinTime="1s"
                        spinnerPrimaryColor="var(--bg-primary-color)"
                        spinnerSecondaryColor="var(--text-primary-color)"
                        spinnerBorderWidth="2px"
                      ></spinner-loader>`
                    : !this.nonBlockedContacts?.length
                      ? html`<no-contacts-placeholder></no-contacts-placeholder>`
                      : html`
                          ${this.nonBlockedContacts.map(
                            contact => html`
                              <contact-tile
                                @click="${() => this.handleContactSelection(contact.userId, contact.userName)}"
                                bgColor="var(--bg-primary-color)"
                                textColor="var(--text-primary-color)"
                                borderWidth="0px 0px 0.5px 0px"
                                borderColor="var(--bg-quaternary-color)"
                                borderStyle="solid"
                                padding="18px 10px"
                                height="auto"
                                width="100%"
                                imageSrc="${contact.userProfileImageUrl}"
                                contactName="${contact.userName}"
                                userId="${contact.userId}"
                                .isCheckBox=${false}
                              ></contact-tile>
                            `,
                          )}
                        `}
                  ${this.isPaginationMember
                    ? html`<div class="loading-container">
                        <spinner-loader
                          height="15px"
                          width="15px"
                          spinTime="1s"
                          spinnerPrimaryColor="var(--bg-primary-color)"
                          spinnerSecondaryColor="var(--text-primary-color)"
                          spinnerBorderWidth="2px"
                        ></spinner-loader>
                      </div>`
                    : ''}
                </div>
              </div>
            </div>
          `;
  }

  handleScroll(event) {
    const element = event.target;
    const threshold = 1;
    if (element.scrollHeight - Math.round(element.scrollTop) <= element.clientHeight + threshold && this.hasMoreMembers && !this.isPaginationMember) {
      this.dispatchEvent(
        new CustomEvent('new-chat-tile-list-scrolled-to-bottom', {
          bubbles: true,
          composed: true,
        }),
      );
    }
  }

  handleInputChange(event) {
    const inputValue = event.target.value;

    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      // If input is empty, fetch all contacts
      if (inputValue.trim() === '') {
        this.dispatchEvent(
          new CustomEvent('new-chat-input-changed', {
            detail: { inputValue: '' },
            bubbles: true,
            composed: true,
          }),
        );
      }
      // If input has 3 or more characters, search with the query
      else if (inputValue.length >= 3) {
        this.dispatchEvent(
          new CustomEvent('new-chat-input-changed', {
            detail: { inputValue },
            bubbles: true,
            composed: true,
          }),
        );
      }
    }, 300);
  }

  handleContactSelection(userId, userName) {
    this.dispatchEvent(
      new CustomEvent('new-chat-contact-selected', {
        detail: { userId, userName },
        bubbles: true,
        composed: true,
      }),
    );
    this.closeNewChatSidebar();
  }

  handleCreateGroupClick() {
    // Clear the search input
    const searchInput = this.shadowRoot.querySelector('.new-chat-sidebar-searchbar input');
    if (searchInput) {
      searchInput.value = '';
    }
    this.showGroupChatContacts = true;
    this.requestUpdate();

    this.dispatchEvent(
      new CustomEvent('create-group-clicked', {
        detail: { isGroup: true },
        bubbles: true,
        composed: true,
      }),
    );
  }

  closeGroupChatOverlay() {
    this.dispatchEvent(
      new CustomEvent('close-group-member-list', {
        detail: {
          isGroup: false,
        },
        bubbles: true,
        composed: true,
      }),
    );
    this.showGroupChatContacts = false;
    this.requestUpdate();
  }

  closeAllOverlays() {
    this.closeGroupChatOverlay();
    if (this.closeNewChatSidebar) {
      this.closeNewChatSidebar();
    }
  }

  handleCreateGroupCastClick() {
    // Clear the search input
    const searchInput = this.shadowRoot.querySelector('.new-chat-sidebar-searchbar input');
    if (searchInput) {
      searchInput.value = '';
    }

    this.showGroupCastContacts = true;
    this.requestUpdate();

    this.dispatchEvent(
      new CustomEvent('create-groupcast-clicked', {
        detail: { isGroup: true },
        bubbles: true,
        composed: true,
      }),
    );
  }

  closeGroupCastOverlay() {
    this.showGroupCastContacts = false;
    this.requestUpdate();
  }
}

customElements.define('new-chat-sidebar', NewChatSidebar);
